import { EmbloomItemType } from '../enums/embloomItemType';

export interface IIndication {
    item: string;
    type: EmbloomItemType;
}

const indicationsToShow = [
    { label: 'Toestandsbeeld', type: EmbloomItemType.primaryIndication },
    { label: 'Overige indicaties', type: EmbloomItemType.secondaryIndication },
    { label: 'Notificaties', type: EmbloomItemType.notification },
    { label: 'Opmerkingen / aanvullende zaken', type: EmbloomItemType.remark },
];

export function getGroupedIndications(indications: IIndication[] | undefined) {
    if (!indications) {
        return [];
    }

    return indicationsToShow
        .map((indicationToShow) => ({
            indications: indications.filter((indication) => indication.type === indicationToShow.type),
            label: indicationToShow.label,
        }))
        .filter((grouped) => grouped.indications.length > 0);
}

export function containsIndicationsToShow(indications: IIndication[] | undefined) {
    return Boolean(
        indications?.some((indication) =>
            indicationsToShow.some((indicationType) => indicationType.type === indication.type)
        )
    );
}
